import Modal from "app/components/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useComponentActions } from "../hooks/useComponentActions";
import {
  selectButtonLoading,
  selectComponentFormData,
  selectFieldLoading,
} from "../redux/selector";
import { componentActions } from "../redux/slice";
import ComponentForm from "./ComponentForm";

interface ComponentModalProps {
  onClose: () => void;
  projectId: string;
}

const ComponentModal: React.FC<ComponentModalProps> = ({
  onClose,
  projectId,
}) => {
  const dispatch = useDispatch();
  const formData = useSelector(selectComponentFormData);
  const isFieldLoading = useSelector(selectFieldLoading);
  const isButtonLoading = useSelector(selectButtonLoading);

  const { handleAddComponent, handleEditComponent } = useComponentActions({
    projectId,
  });

  const handleSubmit = () => {
    if (formData._id) {
      handleEditComponent(() => {
        if (!projectId) return;
        onClose();
        dispatch(componentActions.resetForm());
        dispatch(componentActions.fetchComponentsList({ projectId }));
      });
    } else {
      handleAddComponent(() => {
        if (!projectId) return;
        onClose();
        dispatch(componentActions.resetForm());
        dispatch(componentActions.fetchComponentsList({ projectId }));
      });
    }
  };

  return (
    <Modal
      onClose={onClose}
      onSubmit={handleSubmit}
      submitText={formData._id ? "Save" : "Add"}
      title={isFieldLoading ? "Edit component" : "Add new component"}
      contentClassName="!p-0 !overflow-visible"
      modalClassName="!w-[388px] !max-w-[388px] !overflow-visible bg-white rounded-md flex flex-col pt-5"
      isSubmitDisabled={!formData?.name?.trim()}
      submitLoading={isButtonLoading}
    >
      <ComponentForm />
    </Modal>
  );
};

export default ComponentModal;
